module.exports = __webpack_public_path__ + "img/20200915_074647.4b9285b3.jpg";